import React, { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { Button } from '@folio/stripes/components';
import { useStripes } from '@folio/stripes/core';
var EDITOR_PATH = '/czna-authorities/help-texts';
var READ_PERM = 'czna-authorities.module-settings.item.get';
/**
 * Settings nav button for the help-text editor (CZNA-407).
 *
 * <p>Gated by {@code czna-authorities.module-settings.item.get}: the editor reads the
 * {@code help_text.overrides} row through that route, so a user without it would open a
 * screen that cannot load what it edits. Every role reads the overrides themselves through
 * the narrower {@code help-texts.get}, which says nothing about who may edit them.
 */
var GuidanceTextsNavButton = function () {
    var history = useHistory();
    var pathname = useLocation().pathname;
    var intl = useIntl();
    var stripes = useStripes();
    var handleClick = useCallback(function () {
        if (pathname !== EDITOR_PATH)
            history.push(EDITOR_PATH);
    }, [history, pathname]);
    if (!stripes.hasPerm(READ_PERM))
        return null;
    var isActive = pathname === EDITOR_PATH || pathname.startsWith("".concat(EDITOR_PATH, "/"));
    return (React.createElement(Button, { onClick: handleClick, buttonStyle: isActive ? 'primary' : 'default', fullWidth: true, marginBottom0: true, style: { justifyContent: 'flex-start' }, "aria-current": isActive ? 'page' : undefined },
        React.createElement("span", { style: { marginLeft: '0.5rem' } }, intl.formatMessage({ id: 'ui-czna-authorities.navigation.guidanceTexts' }))));
};
export default GuidanceTextsNavButton;
